const QUESTION_DISPLAY_MOBILE = 8;
const QUESTION_PER_PAGE_DESKTOP = 20;
const DEFAULT_NUMBER_OF_PAGES = 1;
const DESKTOP_PAGE_2_START_INDEX = 5;
const BASE_10 = 10;

export {
  QUESTION_DISPLAY_MOBILE,
  QUESTION_PER_PAGE_DESKTOP,
  DEFAULT_NUMBER_OF_PAGES,
  DESKTOP_PAGE_2_START_INDEX,
  BASE_10
};